export function mapTrainerListOrder(order: string): string {
  const parts = order.split(':')
  if (parts[0] === 'fullName') {
    return `lastName:${parts[1]},firstName:${parts[1]}`
  }
  return order
}